import { v4 as uuidv4 } from "uuid";
export class PAReviewNudgeModel {
    constructor() {
        this.id = uuidv4();
        this.stepName = "";
        this.stepNudges = [];
        this.stepOrder = 0;
    }
}
export default class PAReviewNudge extends PAReviewNudgeModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
